// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-page-index-js": require("gatsby-module-loader?name=component---src-templates-page-index-js!/home/travis/build/signalwerk/doc-starter/src/templates/page/index.js"),
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/home/travis/build/signalwerk/doc-starter/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/home/travis/build/signalwerk/doc-starter/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/home/travis/build/signalwerk/doc-starter/.cache/json/layout-index.json"),
  "styleguide.json": require("gatsby-module-loader?name=path---styleguide!/home/travis/build/signalwerk/doc-starter/.cache/json/styleguide.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/home/travis/build/signalwerk/doc-starter/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/home/travis/build/signalwerk/doc-starter/.cache/json/index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/home/travis/build/signalwerk/doc-starter/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/home/travis/build/signalwerk/doc-starter/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js